import { useSelector } from "react-redux";

export const Footer = () => {
  const company = useSelector((state) => state.company);

  return (
    <footer className="bg-gradient-to-br from-pink-400 to-purple-400 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          <div>
            <div className="flex items-center mb-4">
              <img src="/logo2.png" alt="Logo" className="h-8 w-8" />
              <span className="ml-2 text-xl font-bold">{company.name}</span>
            </div>
            <p className="text-white/90 mb-4">{company.tagline}</p>
            <p className="text-sm text-white/75">Handmade with from Bali</p>
          </div>
          <div>
            <h3 className="font-semibold mb-4 text-lg">Produk Kami</h3>
            <div className="space-y-2">
              {["Topi Rajut", "Tas Rajut", "Syal Rajut", "Gantungan Kunci"].map(
                (product) => (
                  <a
                    key={product}
                    href="#produk"
                    className="block text-white/80 hover:text-white transition-colors"
                  >
                    {product}
                  </a>
                ),
              )}
            </div>
          </div>
          <div>
            <h3 className="font-semibold mb-4 text-lg">Informasi</h3>
            <div className="space-y-2 text-white/80">
              <p>{company.address.split(",")[0]}</p>
              <p>+62 821-4433-5897</p>
              <p>rajutsariasa@gmail.com</p>
              <p>Izin Usaha: {company.license.split(" ")[0]}</p>
            </div>
          </div>
        </div>
        <div className="border-t border-white/20 pt-8 text-center">
          <p className="text-white/90">
            &copy; 2026 {company.name}. ITB STIKOM Bali
          </p>
        </div>
      </div>
    </footer>
  );
};
